<template>
  <Loading v-if="is_loading" class="static" />
  <div v-else class="post-wrap">
    <div class="inner">
      <header class="post-header">
        <h2 v-html="post.title.rendered"></h2>
        <p v-if="post.event_speakers">
          {{ post.event_speakers }}
        </p>
        <time>{{date_str}}</time>
        <p v-if="post.related_festival && post.related_festival.post_title">
          <router-link :to="'/festival/'+post.related_festival.post_name">
            Part of {{post.related_festival.post_title}}
          </router-link>
        </p>
        <p v-if="post.type_description" v-html="post.type_description"></p>
        <p v-if="post.book_price" v-html="post.book_price"></p>

        <Button v-if="event_is_end">This event has ended</Button>
        <Button v-else-if="post.book_text && !post.book_link">{{post.book_text}}</Button>
        <Button v-else-if="post.book_text && post.book_link" :link_url="post.book_link">{{post.book_text}}</Button>
      </header>

      <figure class="featured-image image" v-if="post.featured_image">
        <img :src="post.featured_image.url"  v-images-loaded:on.progress="imageLoaded">
        <figcaption v-if="post.featured_image.alt" v-html="post.featured_image.alt" ref="featured_caption"></figcaption>
      </figure>

      <Content>
        <Link class="membership-link" v-if="$store.state.link && $store.state.text" :post_link="$store.state.link">{{$store.state.text}}</Link>
        <div class="box" v-html="post.content.rendered"></div>
      </Content>
    </div>
    <div class="sections"  v-if="post.sections && post.sections.length !== 0">
      <EventSections v-for="(item, index) in post.sections" :key="'top-'+index" :data="item" :pos="'top'" :order="index" />

      <div class="buy-wrapper">
        <Button class="buy-button" v-if="post.book_text && !post.book_link">{{post.book_text}}</Button>
        <Button class="buy-button" v-else-if="post.book_text && post.book_link" :link_url="post.book_link">{{post.book_text}}</Button>
      </div>

      <EventSections v-for="(item, index) in post.sections" :key="'bottom-'+index" :data="item" :pos="'bottom'" />
    </div>

    <AlsoItems v-if="post.also_posts && post.also_posts.length !== 0" :items="post.also_posts" :festival="post.related_festival" />

    <RelatedGridItems v-if="post.related_posts && post.related_posts.length !== 0" :items="post.related_posts" />
  </div>
</template>

<script>
import GetPreviewUrl from '@/utils/GetPreviewUrl';
import RelatedGridItems from '@/components/RelatedGridItems.vue';
import Content from '@/components/ui/Content.vue';
import Link from '@/components/ui/Link.vue';
import Button from '@/components/ui/Button.vue';
import Loading from '@/components/Loading.vue';
import EventSections from '@/components/EventSections.vue';
import FormatDate from '@/utils/FormatDate';
import imagesLoaded from 'vue-images-loaded';
import AlsoItems from '@/components/AlsoItems.vue';

export default {
    name: 'single-exhibition',
    directives: {
      imagesLoaded,
    },

    data () {
      return {
        post: false,
        is_loading: false,
        date_str: '',
        event_is_end: false,
      }
    },

    components: {
      Content,
      EventSections,
      RelatedGridItems,
      Loading,
      Button,
      Link,
      AlsoItems,
    },

    props: {
      slug: {
        type: String,
        default: ''
      }
    },

    watch: {
      '$route.params': {
        handler(params) {
          // console.log(this.$route.name);
          this.fetchData(params);
        },
        immediate: true,
      }
    },

    methods: {
      fetchData() {
        let curr = new Date();
        curr = new Date(curr.getFullYear() + '-' + ('0' + (curr.getMonth() + 1)).slice(-2) + '-' + ('0' + curr.getDate()).slice(-2) + 'T00:00:00');
        let current_timestamp = parseInt(curr.getTime()/1000);

        this.is_loading = true;
        let api_obj = GetPreviewUrl('events', this.slug);

        console.log({api_obj})
        this.$ajax.get(api_obj.url, api_obj.head).then(res => {
          document.title = 'Charleston — ' + this.decode(res.data[0].title.rendered);

          if (res.data[0].also_posts) {
            res.data[0].also_posts.forEach(item => item.date_str = FormatDate(item));
          } //event_is_end

          let item = res.data[0];
          let s = new Date(item.start_date_timestamp * 1000);
          let d = new Date(item.end_date_timestamp * 1000);

          console.log({item})

          s = s.getFullYear() + '-' + ('0' + (s.getMonth() + 1)).slice(-2) + '-' + ('0' + s.getDate()).slice(-2) + 'T00:00:00';
          d = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2) + 'T00:00:00';

          item.start_date_timestamp = (new Date(s).getTime()/1000);
          item.end_date_timestamp = (new Date(d).getTime()/1000);

          // hide_in_archive

          if(item.hide_in_archive) {
            const existingMetaTag = document.querySelector('meta[name="robots"]');
            if (existingMetaTag) {
              existingMetaTag.remove();
            }

            // Create a new meta tag
            const metaTag = document.createElement("meta");
            metaTag.setAttribute("name", "robots");
            metaTag.setAttribute("content", "noindex");

            // Append the new tag to the <head>
            document.head.prepend(metaTag);
          }


          this.event_is_end = (item.thetype !== '1' && item.thetype !== '2' && item.end_date_timestamp < current_timestamp);

          this.post = res.data[0];
          this.is_loading = false;
          this.date_str = FormatDate(this.post);
        });
      },

      imageLoaded(instance, image) {
        let img_pos = image.img.getBoundingClientRect();
        if (this.$refs.featured_caption) this.$refs.featured_caption.style.width = `${img_pos.width}px`;
      },
    },
}
</script>
<style lang="scss">
  .post-header {
    padding: 0 0 var(--padding);
    text-align: center;
    max-width: 65vw;
    margin: auto;

    h2 {
      font-size: var(--title-size);
      margin: 0 0 1rem;
      line-height: 1.05;
    }

    .ui-button {
      min-width: 18rem;
      margin: 2rem 0 1rem;
    }

  }

  .post-wrap {
    & > .inner > .image {
      display: block;
      margin: 0 0 var(--padding-x2);

      img {
        display: block;
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 80vh;
        margin: auto;
      }

      figcaption {
        font-size: var(--small-size);
        margin: 0 auto;
        margin-top: var(--padding-50);
      }
    }


    .ui-button {
      min-width: 18rem;
      margin: 2rem auto 1rem;
      text-align: center;
    }

    .buy-wrapper {
      width: 100%;
      text-align: center;
      margin-bottom: var(--padding);
    }

    .slideshow-block .swiper-container {
      background: white;
    }
  }

  @media only screen and (max-width: 767px) {
    .post-header {
      max-width: 90rem !important;
    }

    .post-wrap {
      .image figcaption {
        font-size: var(--tiny-size);
        line-height: 1.2;
      }
    }
  }
</style>

